import { ActionTree, Commit } from "vuex";

import { IState } from "./IState";
import { IWebApplication } from "@timesheets/webapp-support";
import { LogoTypeNames } from "@timesheets/constants-common";
import { WebApplicationConstants } from "../setup/WebApplicationConstants";
import { getPortalUrl } from "@gemma/web-common";
import { setTenantColors } from "../utils";

export const actions: ActionTree<IState, IState> = {
  async loadCurrentSession({ commit }: { commit: Commit }, webApplication: IWebApplication) {
    const session = await webApplication.api.getCurrentSession();
    webApplication.setCurrentTenantBranding(session.branding);

    if (WebApplicationConstants.currentTenant !== session.branding.names.currentCanonical) {
      let route =
        getPortalUrl(session.branding.names.currentCanonical, {
          //
          domainPrefix: WebApplicationConstants.domainPrefix,
          subZone: WebApplicationConstants.subZone,
          port: WebApplicationConstants.my.port,
          protocol: WebApplicationConstants.my.protocol,
        }) +
        window.location.pathname +
        window.location.search;

      window.location.replace(route);
    }

    setTenantColors(session.branding.names.currentCanonical, session.branding.colors);
    commit("setCurrentSession", session);
  },
  async setCurrentSessionProperties({ commit }: { commit: Commit }, { isEnabled, emailAddress, fullname }: { isEnabled?: boolean; emailAddress?: string; fullname?: string } = {}) {
    commit("mutateCurrentSessionProperties", { isEnabled, emailAddress, fullname });
  },
  updateLogoTimestamp({ commit }: { commit: Commit }, { logoType, tenantName }: { logoType: LogoTypeNames; tenantName: string }) {
    const timestamp = new Date().valueOf();
    commit("setLogoTimestamp", { timestamp, logoType, tenantName });
  },
};
